import {RenewableTermPolicyPremiumChange as RenewableTermPolicyPremiumChangeLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type RenewableTermPremiumChangeProps = {
  renewableTermPolicyPremiumChangeLetter: RenewableTermPolicyPremiumChangeLetter;
};

const RenewableTermPremiumChange = (props: RenewableTermPremiumChangeProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.renewableTermPolicyPremiumChangeLetter.insuredName} ddprivacy="mask"/>
      <CardField name={'Owner Name'} value={props.renewableTermPolicyPremiumChangeLetter.ownerName} ddprivacy="mask"/>
      <CardField
        name={'Owner Address'}
        value={props.renewableTermPolicyPremiumChangeLetter.ownerAddress!.fullAddress} ddprivacy="mask"
      />
      <CardField name={'Policy Number'} value={props.renewableTermPolicyPremiumChangeLetter.policyNumber} ddprivacy="mask"/>
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.renewableTermPolicyPremiumChangeLetter.date)} />
      <CardField name={'Agent Number'} value={props.renewableTermPolicyPremiumChangeLetter.agentNumber} />
      <CardField
        name={'Current Premium'}
        value={toMoneyValue(props.renewableTermPolicyPremiumChangeLetter.currentPremium)}
      />
      <CardField name={'New Premium'} value={toMoneyValue(props.renewableTermPolicyPremiumChangeLetter.newPremium)} />
      <CardField
        name={'Renewal Date'}
        value={toFormattedDateAsUTC(props.renewableTermPolicyPremiumChangeLetter.renewalDate)}
      />
    </>
  );
};

export default RenewableTermPremiumChange;
